import axios from 'axios';

const environment = {
  local: {
    apiGeneral: 'http://localhost:3334',
  },
  production: {
    apiGeneral: process.env.REACT_APP_URL_BASE as string,
  },
};

const baseURL =
  process?.env?.NODE_ENV === 'development'
    ? environment.production
    : environment.production;

export const dashboardUrl = baseURL.apiGeneral.replace(/\/$/, '');

export const apiGeneral = axios.create({
  baseURL: baseURL.apiGeneral,
  // headers: {},
  // withCredentials: true,
});

export const queryBuilder = (payload: Record<string, any>): string => {
  const validObject: Record<string, any> = {};

  for (const [param, value] of Object.entries(payload)) {
    if (value) Object.assign(validObject, { [param]: value });
  }

  const searchParams = new URLSearchParams(validObject).toString();
  return searchParams;
};

export const formDataBuilder = (payload: Record<string, any>): FormData => {
  const formData = new FormData();

  for (const [param, value] of Object.entries(payload)) {
    if (value instanceof File) {
      formData.append(param, value, value.name);
    } else if (value) {
      formData.append(param, value);
    }
  }

  return formData;
};
